import { GlobalErrors } from "@/enum/constants";
import { loadTranslator } from "./translationHelper";
import { ErrorResponse } from "@/custom-models/errorResponse";

const i18n = loadTranslator();

export function parseErrorResponse(errorData: ErrorResponse) {
    if (!errorData) return null;
    const t = i18n.global.t;
    let message = t("oops_technical_problems_try_again_in_a_few_minutes");

    if (Array.isArray(errorData.messages) && errorData.messages.length > 0) {
        message = errorData.messages[0];
    }

    if (typeof errorData.messages === "string") {
        message = errorData.messages;
    }

    if (typeof errorData.message === "string") {
        message = errorData.message;
    }

    return {
        timestamp: errorData.timestamp || Date.now(),
        status: String(errorData.status || GlobalErrors.ERROR_500 ),
        messages: message,
    };
}

export function buildPaymentError(data: ErrorResponse) {
    return {
        success: false,
        data: data
    }
}